import type { TrainingTimeOfDay } from '@cadencia/contracts';

/**
 * El turno de una sesion concreta.
 *
 * VIVIA EN `nutrition/meal-schedule.ts` HASTA EL 21/09/2026, y se rescato al
 * retirar la nutricion. Nacio alli porque su primer consumidor era el reparto
 * de comidas alrededor del entrenamiento, pero lo que resuelve es un dato de
 * ENTRENAMIENTO: a que hora se entrena esta sesion. Sus dos fuentes son
 * `training_sessions.training_time_of_day` y
 * `user_preferences.default_training_time_of_day`, y ninguna de las dos es una
 * tabla de nutricion.
 *
 * Borrarlo con su fichero habria sido el error que el §4 del encargo avisa:
 * eliminar un modulo por su nombre sin mirar que hay dentro.
 *
 * DOS CAMPOS, UNA VERDAD. El de la sesion es lo que pasa en ESA sesion; la
 * preferencia es lo que se supone cuando nadie ha dicho nada de ella. No son
 * dos fuentes en competencia: la segunda solo se mira cuando la primera esta
 * nula, y esta es la unica funcion que las mira. Todo lo demas pregunta aqui.
 *
 * Sin la preferencia, las sesiones que ya existian se habrian quedado sin turno
 * para siempre. Un motor con la entrada cegada no falla: decide algo plausible,
 * y por eso no lo mira nadie.
 */
export function resolveTrainingTimeOfDay(
  sessionValue: TrainingTimeOfDay | null,
  habitual: TrainingTimeOfDay,
): TrainingTimeOfDay {
  return sessionValue ?? habitual;
}
